import $ from 'jquery';
import React from 'react';
import {Spinner} from 'spin.js';


export default class Spin extends React.Component {

    constructor(props) {
        super(props);

        this.defaultConfig = {
              lines: 13 // The number of lines to draw
            , length: 12 // The length of each line
            , width: 7 // The line thickness
            , radius: 19 // The radius of the inner circle
            , scale: 0.25 // Scales overall size of the spinner
            , corners: 0 // Corner roundness (0..1)
            , color: '#cc162b' // #rgb or #rrggbb or array of colors
            , opacity: 0.25 // Opacity of the lines
            , rotate: 0 // The rotation offset
            , direction: 1 // 1: clockwise, -1: counterclockwise
            , speed: 0.6 // Rounds per second
            , trail: 60 // Afterglow percentage
            , zIndex: 2e9 // The z-index (defaults to 2000000000)
            , className: 'spinner' // The CSS class to assign to the spinner
            , top: '9px' // Top position relative to parent
            , left: '17px' // Left position relative to parent
            , position: 'absolute' // Element positioning
        };

        this.config = {};
    }

    componentDidMount () {

        // do we really wat the whole jquery deendency, only for this small utility function?
        $.extend(this.config, this.defaultConfig, (this.props.config ? this.props.config : {}));

        this.spinner = new Spinner(this.config);
        if (!this.props.stopped) {
            this.spinner.spin(this.refs.container);
        }
    }

    componentWillReceiveProps (newProps) {
        if (newProps.stopped === true && !this.props.stopped) {
            this.spinner.stop();
        } else if (!newProps.stopped && this.props.stopped === true) {
            this.spinner.spin(this.refs.container);
        }
    }

    componentWillUnmount () {
        this.spinner.stop();
    }

    render () {
        return (
            <div ref="container" className="spinner"/>
        );
    }
};